<template>
  <el-dialog
    width="500px"
    modal-append-to-body
    append-to-body
    custom-class="dialog_box"
    :title="edit ? '编辑企业' : '新建企业'"
    :visible.sync="visible"
    :before-close="beforeClose"
  >
    <el-form
      ref="companyForm"
      :model="formData"
      :rules="formRules"
      size="small"
      label-position="right"
      label-width="80px"
      label-suffix=":"
    >
      <el-form-item label="企业名" prop="enterpriseName" required>
        <el-input
          v-model="formData.enterpriseName"
          maxlength="12"
          show-word-limit
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item label="企业logo" prop="enterpriseLogo">
        <el-upload
          ref="companyUpload"
          class="upload-demo"
          accept=".png,.svg,.jpg"
          action=""
          :auto-upload="false"
          :on-change="importModel"
          :on-remove="removeFile"
        >
          <el-button icon="el-icon-document-add" size="small" plain>
            {{ edit ? "重新上传" : "上传logo" }}
          </el-button>
          <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
        </el-upload>
      </el-form-item>
    </el-form>
    <div class="form_footer">
      <el-button size="small" @click="beforeClose">取消</el-button>
      <el-button size="small" type="primary" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import formRules from "./rules";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    enterpriseList: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      defalut: false,
    },
    initFormData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {
        enterpriseName: "",
        enterpriseLogo: "",
      },
      formRules: formRules,
      fileList: [],
    };
  },
  watch: {
    visible(val) {
      if (val && this.edit) {
        this.initData();
      }
    },
  },
  methods: {
    initData() {
      if (this.edit) {
        this.formData = { ...this.initFormData };
        this.fileList = [
          { url: this.initFormData.enterpriseLogo, name: "企业logo.png" },
        ];
      }
    },
    submit() {
      const val = { ...this.formData };
      if (this.fileList.length === 0) {
        delete val.enterpriseLogo;
      } else {
        val.enterpriseLogo = this.fileList[0].url;
      }
      this.$refs.companyForm
        .validate()
        .then(() => {
          const url = this.edit ? "/enterprise/update" : "/enterprise/insert";
          this.$http({
            url,
            method: "post",
            data: val,
          }).then((res) => {
            if (res.code === 200) {
              const message = this.edit ? "编辑成功" : "添加成功";
              this.$message({
                message,
                type: "success",
              });
              this.beforeClose();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch((err) => {
          console.log("表单校验失败");
        });
    },
    // 关闭前的回调
    beforeClose() {
      this.formData = {
        enterpriseName: "",
        enterpriseLogo: "",
      };
      this.fileList = [];
      this.$refs.companyUpload.clearFiles();
      this.$emit("update");
      this.$emit("close-modal");
      this.$refs.companyForm.resetFields();
    },
    //格式限制
    onFormat(file) {
      let canUpload = true;
      const { size, name = "" } = file;
      const isGt1M = size / 1024 / 1024 > 1; //是否大于1M
      if (isGt1M) {
        canUpload = false;
        this.$message.warning("上传文件大小超过1M，请重新上传");
      }
      // , "jpeg"  "webp"
      if (!["png", "jpg"].includes(name.split(".")[1])) {
        canUpload = false;
        this.$message.warning("请上传正确的图片文件类型哦");
      }
      if (!canUpload) {
        this.fileList = [];
        this.$refs.companyUpload.clearFiles();
      }
      return canUpload;
    },
    // 导入logo
    importModel(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
      // // "jpeg" "webp"
      // if (!["png", "jpg"].includes(file.name.split(".")[1])) {
      //   this.$message.warning("请上传正确的图片文件类型哦");
      //   this.fileList = [];
      //   this.$refs.companyUpload.clearFiles();
      //   return;
      // }
      //文件校验，不通过则停止执行
      const isContinue = this.onFormat(file);
      if (!isContinue) return;
      let param = new FormData();
      // 将得到的文件流添加到FormData对象
      param.append("file", file.raw, file.name);
      // param.append("fileType", "enterprise");
      this.$http({
        url: "/upload",
        data: param,
        type: "upload",
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
          if (res.code === 0) {
            // this.fileList[0].url = res.data;
            this.fileList = [
              {
                url:
                  "http://gov.eagle.datastory.com.cn/api/v0.5/file/images/" +
                  res.data.fileName,
                name: file.name,
              },
            ];
            this.$message({
              message: "上传成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "上传失败,请重新上传",
              type: "error",
            });
            this.fileList = [];
            this.$refs.companyUpload.clearFiles();
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message({
            message: "上传失败,请重新上传",
            type: "error",
          });
          this.fileList = [];
          this.$refs.companyUpload.clearFiles();
        });
    },
    removeFile() {
      this.fileList = [];
    },
  },
};
</script>

<style lang="scss">
.dialog_box {
  border-radius: 10px;
}
.form_footer {
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/pages/index/views/companyManage/companyEdit.vue